export default __webpack_public_path__ + "static/mobile-app-results-screen@2x-3468ed3451f08883b3e1f1e568eddbab.webp";